import axios from 'axios';
import config from '../config';
import { Organization } from '../interfaces';

export const getOrganizations = (): Promise<Organization[]> => {
    return axios.get(`${config.API_URL}/organizations`).then((response: any) => {
        return response.data.data.organizations;
    });
};
